import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ChangePasswordComponent } from 'src/app/changePassword/change-password/change-password.component';
import { constant } from 'src/app/constant/constant.stage';
import { userAccess } from 'src/app/models/UserAccess';
import { ExcelDownloadStateService } from 'src/app/services/ReportServices/excelsignalr.service';
import { UserService } from 'src/app/services/User/user.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  excelDownloading$ = this.excelSignalRService.excelDownloading$;
  excelDownloaded$ = this.excelSignalRService.excelDownloaded$;
  lastReadyJobId: string | null = null;

  userAccessData!: userAccess;//this variable will hold user data
  notifications: string[] = [];

  constructor(private router: Router, private dialogService: MatDialog, private userService: UserService, private utilityService: UtilityService, public excelSignalRService: ExcelDownloadStateService, private snackBar: MatSnackBar) {
    // Listen for job ready and store the jobId
    this.excelSignalRService.excelReady$.subscribe(jobId => {
      this.lastReadyJobId = jobId;
    });
  }


  ngOnInit(): void {
    this.userAccessData = this.userService.getUsersAccessData();
    this.checkStoreUpdate();
  }

  logoutUser() {
    // Clear the session from storage
    this.userService.logOutUser();

    // Clear pending Excel jobs from localStorage
    localStorage.removeItem('pendingExcelJobIds');

    // CRITICAL: Force the service to update its observable
    this.excelSignalRService.clearAllPendingJobs();
  }

  changePassword() {
    const taxModalRef = this.dialogService.open(ChangePasswordComponent, {
      width: '40%',
      disableClose: false,
      data: { headerTitle: "Change Password", userData: '' }
    });

    taxModalRef.afterClosed().subscribe(result => {
      // Only show if password was changed (you may need to check result value if dialog returns status)
      if (result === 'SUCCESS') {
        this.utilityService.showAlert(
          constant.KEY_WARNING,
          constant.PASSWORD_CHANGED_QR_UPDATE_TITLE,
          constant.PASSWORD_CHANGED_QR_UPDATE_MSG
        );
      }
    });
  }

  editLoggedinUserProfile() {

    let userData = {
      userName: this.userAccessData.userName
    };

    this.userService.getUserByUserName(userData).subscribe(response => {

      if (response.result == "SUCCESS") {
        var receivedUserResponse = JSON.parse(response.data);

        const returnUrl = this.router.url;

        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/user'], {
            state: {
              editUserData: receivedUserResponse,
              cameFromHeader: true,
              returnUrl: returnUrl

            }
          });
        });
      }
      else {

        this.utilityService.showAlert(
          "ERROR",
          "Failed",
          "Error while fetching the user data"
        );
      }
    });
  }

  checkStoreUpdate() {
    this.notifications = [];
    const storeDetails = JSON.parse(sessionStorage.getItem('storeDetails') || 'null');

    if (!storeDetails || (!storeDetails.rxLink && !storeDetails.primeRxCloudURL)) {
      this.notifications.push('⚠️ Pending store update.');
    }
  }

  clearNotifications() {
    this.notifications = []; // Clears the notifications array
  }

  handleDownloadClick() {
    // Show a snackbar and only hide the icon after the user closes it
    const snackBarRef = this.snackBar.open(
      'Excel file downloaded. You can find it in your downloads folder.',
      'OK',
      { duration: 3000, verticalPosition: 'top' }
    );

    snackBarRef.afterDismissed().subscribe(() => {
      this.excelSignalRService.onExcelIconClicked(); // Hide the icon after snackbar closes
    });
  }
}
